import WebWorker from '@blade-sxp/ota-management/pages/utils/md5.worker?worker';
// const webWorkerUrl = '@blade-sxp/ota-management/pages/utils/md5.worker';
export async function splitFile(fileRaw, CHUNKSIZE) {
    const file = fileRaw;
    const chunkList = [];
    return new Promise((resolve) => {
        const fileReader = new FileReader();
        const blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice;
        let currentChunk = 0;
        let chunkSize = 0;
        let chunks = 0;
        if (file.size < CHUNKSIZE) {
            chunkSize = file.size;
            chunks = 1;
        }
        else {
            chunkSize = CHUNKSIZE;
            chunks = Math.ceil(file.size / chunkSize);
        }
        // const spark = new SparkMD5.ArrayBuffer();
        fileReader.onload = async (e) => {
            const currChunk = e.target.result;
            // spark.append(currChunk);
            // const wa = CryptoJs.lib.WordArray.create(currChunk);
            // const sha256 = CryptoJs.SHA256(wa).toString();
            chunkList.push({
                chunk: new Blob([currChunk]),
                // sha256_hex: sha256,
                size: currChunk.byteLength,
            });
            currentChunk++;
            if (currentChunk < chunks) {
                loadNext();
            }
            else {
                // const hash = spark.end();
                // file.hash = hash;
                resolve(chunkList);
            }
        };
        fileReader.onerror = function () {
            console.warn('oops, something went wrong.');
            resolve([]);
        };
        function loadNext() {
            const start = currentChunk * chunkSize;
            const end = start + chunkSize >= file.size ? file.size : start + chunkSize;
            fileReader.readAsArrayBuffer(blobSlice.call(file, start, end));
        }
        loadNext();
    });
}
export async function calculateMD5(fileRaw, CHUNKSIZE) {
    return new Promise((resolve) => {
        // const worker = new Worker(webWorkerUrl);
        const worker = new WebWorker();
        worker.postMessage({ fileRaw, CHUNKSIZE });
        worker.onmessage = (e) => {
            resolve(e.data?.md5);
        };
    });
}
export class SendBinaryDataUtil {
    oReq;
    constructor(url, headers, method) {
        this.oReq = new XMLHttpRequest();
        this.oReq.open(method, url);
        this.oReq.setRequestHeader('Content-Meta', headers);
        this.oReq.setRequestHeader('Content-Type', 'application/octet-stream');
    }
    sendData(data, onprogressCallback) {
        return new Promise((resolve, reject) => {
            if (!this.oReq) {
                reject(new Error());
            }
            this.oReq.onload = (oEvent) => {
                this.oReq.upload.removeEventListener('progress', onprogressCallback);
                resolve(oEvent);
            };
            this.oReq.upload.addEventListener('progress', onprogressCallback);
            this.oReq.onerror = function (oEvent) {
                reject(oEvent);
            };
            this.oReq.onabort = function (oEvent) {
                console.log('abort');
                reject(new Error('abort'));
            };
            this.oReq.send(data);
        });
    }
    abort() {
        this.oReq && this.oReq.abort();
    }
}
